import { useEffect, useState } from "react";

import { getStoredUser, USER_EVENT } from "./userStorage";

export const useStoredUser = () => {
  const [user, setUser] = useState(() => getStoredUser());

  useEffect(() => {
    const handler = () => setUser(getStoredUser());
    window.addEventListener("storage", handler);
    window.addEventListener(USER_EVENT, handler);
    return () => {
      window.removeEventListener("storage", handler);
      window.removeEventListener(USER_EVENT, handler);
    };
  }, []);

  return user;
};
